import { IApiaField, IApiaForm } from '../../../../../../../../JSApi/types';
import propsStore from '../../../../../../../../store/propsStore/propsStore';

export const getSortedKeys = (
  toSort: Record<
    string,
    { form: IApiaForm; field: IApiaField; rowIdx?: number }
  >,
) => {
  const sortedValues = Object.keys(toSort).sort((a, b) => {
    const aVal = toSort[a];
    const bVal = toSort[b];
    let propsA = propsStore.getFieldProps(aVal.field.fldId as string);
    let propsB = propsStore.getFieldProps(bVal.field.fldId as string);
    if (
      propsA.parentGridId &&
      propsB.parentGridId &&
      propsA.parentGridId === propsB.parentGridId
    ) {
      if (aVal.rowIdx === bVal.rowIdx)
        return (propsA.gridColumn as number) - (propsB.gridColumn as number);
      else return (bVal.rowIdx as number) - (bVal.rowIdx as number);
    } else if (propsA.parentGridId)
      propsA = propsStore.getFieldProps(propsA.parentGridId);
    else if (propsB.parentGridId)
      propsB = propsStore.getFieldProps(propsB.parentGridId);

    if (propsA.field.x === propsB.field.x)
      return propsA.field.y - propsB.field.y;
    else if (propsA.field.x < propsB.field.x) return 1;
    else if (propsA.field.x > propsB.field.x) return -1;
    return 0;
  });
  return sortedValues;
};
